import React, { Component } from 'react';
import { Modal, Checkbox, Col } from 'antd';

import styles from './index.less';

class SelectTarget extends Component {
  constructor(props) {
    super(props)
    const { selectedTargetIds } = props
    this.state = { 
      currentTargetId:selectedTargetIds
     }
  }

   // 选择完成后的回调
  handleOk = () => {
    const { onOk } = this.props;
    const { currentTargetId } = this.state
    if(onOk) {
      onOk(currentTargetId)
    }
  }

  // 受控选择框发生改变时的回调
  handleChangeChecked = (values) => {
    this.setState({
      currentTargetId:values
    })  
  }

  renderList = () => {
    const { orgList } = this.props;
    const { currentTargetId } = this.state
    return (
      <Checkbox.Group value={currentTargetId} onChange={this.handleChangeChecked}>
        {orgList.map(({orgId, orgName}) => {
          return (
            <Col span={24} key={orgId}>
              <Checkbox value={orgId} key={orgId}>{orgName}</Checkbox>
            </Col>
          )
        })}
      </Checkbox.Group>
    )
  }

  render() {
    const { onCancel } = this.props;
    return (
      <Modal
        title="请选择评估对象"
        visible
        centered
        onOk={this.handleOk}
        onCancel={() => onCancel()}
        wrapClassName={styles.targetModal}
      >
        <div className="modal-body-wrap">
          {this.renderList()}
        </div>
      </Modal>
    );
  }
}

export default SelectTarget;